export default "__VITE_ASSET__ba069131__"